import { Grid, Switch, Tooltip } from "@material-ui/core";
import React from "react";
import { handleKeyDown } from "../../common/common";
import {
  expenseResultField,
  fuelPriceOptions
} from "../../constants";
import CustomShowModal from "../Common/CustomShowModal";
import DailyExpensesModal from "./DailyExpensesModal";
import ExpenseBreakdownModal from "./ExpenseBreakdownModal";
import { fmt3 } from "../../utils";

function MarginAndAllowances(props) {
  const {
    calculatorData = {},
    setMarginModal = () => { },
    setCalculatorData = () => { },
    selectedVessels = {},
    setSelectedVessels = () => { },
    syncBunker = false,
    setSyncBunker = () => { },
    setSupplyModal = () => { },
    onChangeSyncBunker = () => { },
    onChangeSelectedVessel = () => { },
    isOverride = false,
    setIsOverride = () => { },
    isFromSingleVesselCalcy = false,
    isFromVesselVessel = false,
    isContractEstimate = false,
    onChangeClientQuery = () => { },
    tcAdcom = 0,
  } = props;

  let vessel =
    (selectedVessels &&
      selectedVessels.vessel &&
      JSON.parse(selectedVessels.vessel)) ||
    {};

  // const delayUpdateOperation = useCallback(
  //   _.debounce(
  //     (fuelType, newClientQuery) => onUpdateFuelPrice(fuelType, newClientQuery),
  //     500
  //   ),
  //   []
  // );

  const { clientQuery = {}, portOperation = [] } = calculatorData || {};
  const { dailyExpenses = [] } = clientQuery || {};
  const [showExpensesModal, setShowExpensesModal] = React.useState(false);
  const [expenseModalField, setExpenseModalField] = React.useState(null);

  // Local string state for margin inputs — prevents cursor-jump caused by
  // value={Number(x).toFixed(2)} reformatting on every keystroke.
  const [localDwf, setLocalDwf] = React.useState("");
  const [localSpeedFactor, setLocalSpeedFactor] = React.useState("");
  const [localSpeedReduce, setLocalSpeedReduce] = React.useState("");
  const [localBnkrFactor, setLocalBnkrFactor] = React.useState("");
  const [focusedMarginField, setFocusedMarginField] = React.useState(null);
  let {
    fuelCalculationMethod = "DEFAULT",
    fuelType = "TYPE0",
    lsFuelPriceType0 = 0,
    lsFuelPriceType1 = 0,
    lsFuelPriceType2 = 0,
    lsFuelPriceType3 = 0,
    lsFuelPriceType4 = 0,
    hsFuelPriceType0 = 0,
    hsFuelPriceType1 = 0,
    hsFuelPriceType2 = 0,
    hsFuelPriceType3 = 0,
    hsFuelPriceType4 = 0,
    mgoFuelPriceType0 = 0,
    mgoFuelPriceType1 = 0,
    mgoFuelPriceType2 = 0,
    mgoFuelPriceType3 = 0,
    mgoFuelPriceType4 = 0,
  } = clientQuery || {};

  const {
    bnkFuelMain = "",
    bnkFuelEca = "",
    bnkFuelMgo = "",
  } = selectedVessels || {};

  let fuelTypePrices = {
    TYPE0: {
      normal: hsFuelPriceType0 || 0,
      eca: lsFuelPriceType0 || 0,
      mgo: mgoFuelPriceType0 || 0,
    },
    TYPE1: {
      normal: hsFuelPriceType1 || 0,
      eca: lsFuelPriceType1 || 0,
      mgo: mgoFuelPriceType1 || 0,
    },
    TYPE2: {
      normal: hsFuelPriceType2 || 0,
      eca: lsFuelPriceType2 || 0,
      mgo: mgoFuelPriceType2 || 0,
    },
    TYPE3: {
      normal: hsFuelPriceType3 || 0,
      eca: lsFuelPriceType3 || 0,
      mgo: mgoFuelPriceType3 || 0,
    },
    TYPE4: {
      normal: hsFuelPriceType4 || 0,
      eca: lsFuelPriceType4 || 0,
      mgo: mgoFuelPriceType4 || 0,
    },
  };
  const vesselOnChangeHandler = (e) => {
    const { name: key = "", value = "" } = e?.target || {};
    if (typeof onChangeSelectedVessel === "function") {
      onChangeSelectedVessel({ target: { name: key, value } }, true);
    }
  };

  const onChangeHandler = (e) => {
    const { name: key = "", value = "" } = e.target;
    let newCargoDetails = {};
    if (key === "fuelType") {
      vessel.fuelType = value;
      setSelectedVessels({
        ...selectedVessels,
        vessel: JSON.stringify(vessel),
      });
      const currentType = value.replace("TYPE", "");
      newCargoDetails[`fuelPriceType${currentType}Hsfo`] = Number(
        clientQuery[`hsFuelPriceType${currentType}`]
      );
      newCargoDetails[`fuelPriceType${currentType}Lsfo`] = Number(
        clientQuery[`lsFuelPriceType${currentType}`]
      );
      newCargoDetails[`fuelPriceType${currentType}Mgo`] = Number(
        clientQuery[`mgoFuelPriceType${currentType}`]
      );
    }
    if (key === "fuelCalculationMethod" && value !== "DEFAULT") {
      setSyncBunker(true);
    } else {
      setSyncBunker(false);
    }

    setCalculatorData({
      ...calculatorData,
      clientQuery: {
        ...calculatorData.clientQuery,
        [key]: value,
      },
      portOperation: calculatorData.portOperation.map((item) => {
        return {
          ...item,
          cargoDetails: {
            ...item.cargoDetails,
            ...newCargoDetails,
          },
        };
      }),
    });
  };

  const onChangeFuelPrice = (e) => {
    const { name = "", value = "" } = e.target;
    if (!vessel.fuelType) vessel.fuelType = "TYPE0";

    let newClientQuery = { ...clientQuery };
    let newCargoDetails = {};
    const currentType = fuelType.replace("TYPE", "");
    if (name === "normal") {
      newClientQuery[`hsFuelPriceType${currentType}`] = value;
    }
    if (name === "eca") {
      newClientQuery[`lsFuelPriceType${currentType}`] = value;
    }
    if (name === "mgo") {
      newClientQuery[`mgoFuelPriceType${currentType}`] = value;
    }

    if (!fuelCalculationMethod || fuelCalculationMethod === "DEFAULT") {
      // newCargoDetails[`fuelPriceType${currentType}Hsfo`] = Number(newClientQuery[`hsFuelPriceType${currentType}`])
      // newCargoDetails[`fuelPriceType${currentType}Lsfo`] = Number(newClientQuery[`lsFuelPriceType${currentType}`])
      // newCargoDetails[`fuelPriceType${currentType}Mgo`] = Number(newClientQuery[`mgoFuelPriceType${currentType}`])

      if (!isOverride) {
        setSelectedVessels({
          ...selectedVessels,
          bnkPriceDeliveryhs: Number(
            newClientQuery[`hsFuelPriceType${currentType}`]
          ),
          bnkPriceDeliveryls: Number(
            newClientQuery[`lsFuelPriceType${currentType}`]
          ),
          bnkPriceDeliverymgo: Number(
            newClientQuery[`mgoFuelPriceType${currentType}`]
          ),
          bnkPriceRedeliveryhs: Number(
            newClientQuery[`hsFuelPriceType${currentType}`]
          ),
          bnkPriceRedeliveryls: Number(
            newClientQuery[`lsFuelPriceType${currentType}`]
          ),
          bnkPriceRedeliverymgo: Number(
            newClientQuery[`mgoFuelPriceType${currentType}`]
          ),
          bnkPriceSettlemenths: Number(
            newClientQuery[`hsFuelPriceType${currentType}`]
          ),
          bnkPriceSettlementls: Number(
            newClientQuery[`lsFuelPriceType${currentType}`]
          ),
          bnkPriceSettlementmgo: Number(
            newClientQuery[`mgoFuelPriceType${currentType}`]
          ),
        });
      }

      setCalculatorData({
        ...calculatorData,
        portOperation: calculatorData.portOperation.map((item, index) => {
          if (isOverride && item.operation === "Commence") return item;
          return {
            ...item,
            cargoDetails: {
              ...item.cargoDetails,
              ...newCargoDetails,
            },
          };
        }),
        clientQuery: newClientQuery,
      });
      // delayUpdateOperation(fuelType, newClientQuery);
    }
  };

  // const onUpdateFuelPrice = (fuelType, newClientQuery) => {
  //   actions.updateFuelPrice(fuelType, newClientQuery);
  // };

  const onChangePortMarginValue = (e) => {
    const { name = "", value = "" } = e.target || {};
    let updatedOperation = [];
    if (name === "dwf") {
      updatedOperation = portOperation.map((item) => ({
        ...item,
        dwf: Number(value),
      }));
    } else {
      updatedOperation = portOperation.map((item) => ({
        ...item,
        cargoDetails: { ...item.cargoDetails, [name]: Number(value) },
      }));
    }
    setCalculatorData({
      ...calculatorData,
      portOperation: updatedOperation,
    });
  };

  const checkDiff = (a) => {
    return a.length !== 0 && new Set(a).size === 1;
  };

  let dwfArray = [];
  let speedFactorArray = [];
  let speedReduceArray = [];
  let bunkerConArray = [];

  for (let i = 0; i < portOperation.length; i++) {
    const operation = portOperation[i];
    const { cargoDetails = {}, dwf = 0 } = operation || {};
    const { speedFactor = 0, speedReduce = 0, bnkrFactor = 0 } = cargoDetails;
    dwfArray.push(dwf);
    speedFactorArray.push(speedFactor);
    speedReduceArray.push(speedReduce);
    bunkerConArray.push(bnkrFactor);
  }

  let showDwfViewReset = checkDiff(dwfArray);
  let showSpeedFactorViewReset = checkDiff(speedFactorArray);
  let showSpeedReduceViewReset = checkDiff(speedReduceArray);
  let showBunkerConViewReset = checkDiff(bunkerConArray);

  const onChangeViewReset = (name) => {
    let updatedOperation = [];
    if (name === "dwf") {
      updatedOperation = portOperation.map((item) => ({ ...item, dwf: 0 }));
    } else {
      updatedOperation = portOperation.map((item) => ({
        ...item,
        cargoDetails: { ...item.cargoDetails, [name]: 0 },
      }));
    }
    setCalculatorData({
      ...calculatorData,
      portOperation: updatedOperation,
    });
  };

  const onChangeQueryValues = (e) => {
    const { name = "", value = "" } = e.target;
    let newPortOperation = [...portOperation];
    setCalculatorData({
      ...calculatorData,
      clientQuery: {
        ...clientQuery,
        [name]: Number(value),
      },
      portOperation: newPortOperation,
    });
  };

  let dwfValue = 0;
  let speedFactorValue = 0;
  let speedReduceValue = 0;
  let bnkrFactorValue = 0;
  if (Array.isArray(portOperation) && portOperation.length) {
    dwfValue = portOperation[0].dwf || 0;
    speedFactorValue =
      (portOperation[0].cargoDetails &&
        portOperation[0].cargoDetails.speedFactor) ||
      0;
    speedReduceValue =
      (portOperation[0].cargoDetails &&
        portOperation[0].cargoDetails.speedReduce) ||
      0;
    bnkrFactorValue =
      (portOperation[0].cargoDetails &&
        portOperation[0].cargoDetails.bnkrFactor) ||
      0;
  }

  // Sync local display state from props whenever the field is NOT focused
  // (i.e., an external change came in — modal edits, reset, etc.)
  React.useEffect(() => {
    if (focusedMarginField !== "dwf")
      setLocalDwf(fmt3(Number(dwfValue)));
  }, [dwfValue, focusedMarginField]);

  React.useEffect(() => {
    if (focusedMarginField !== "speedFactor")
      setLocalSpeedFactor(fmt3(Number(speedFactorValue)));
  }, [speedFactorValue, focusedMarginField]);

  React.useEffect(() => {
    if (focusedMarginField !== "speedReduce")
      setLocalSpeedReduce(fmt3(Number(speedReduceValue)));
  }, [speedReduceValue, focusedMarginField]);

  React.useEffect(() => {
    if (focusedMarginField !== "bnkrFactor")
      setLocalBnkrFactor(fmt3(Number(bnkrFactorValue)));
  }, [bnkrFactorValue, focusedMarginField]);

  // Handlers wired to local state — keep raw string while typing
  const onMarginLocalChange = (fieldName, setter) => (e) => {
    setter(e.target.value);
  };

  // On blur: commit value to parent state and reformat display
  const onMarginBlur = (fieldName, setter) => (e) => {
    const numVal = parseFloat(e.target.value) || 0;
    setter(fmt3(numVal));
    setFocusedMarginField(null);
    // Synthesise an event object compatible with onChangePortMarginValue
    onChangePortMarginValue({ target: { name: fieldName, value: String(numVal) } });
  };

  const selectedFuelType =
    fuelPriceOptions.find((item) => item.value === fuelType) || {};

  const {
    bnkDelhs = 0,
    bnkDells = 0,
    bnkDelmgo = 0,
    bnkPriceDeliveryhs = 0,
    bnkPriceDeliveryls = 0,
    bnkPriceDeliverymgo = 0,
    bnkPriceRedeliveryhs = 0,
    bnkPriceRedeliveryls = 0,
    bnkPriceRedeliverymgo = 0,
    bnkPriceSettlemenths = 0,
    bnkPriceSettlementls = 0,
    bnkPriceSettlementmgo = 0,
    bnkQtyRedeliveryhs = 0,
    bnkQtyRedeliveryls = 0,
    bnkQtyRedeliverymgo = 0,
    bnkRedeliveryQtyTolerancehs = 0,
    bnkRedeliveryQtyTolerancels = 0,
    bnkRedeliveryQtyTolerancemgo = 0,
  } = selectedVessels || {};

  return (
    <Grid container>
      <Grid item xs={12}>
        <div>
          <Grid container>
            <Grid item xs={12} className="calculator-section-header margin-allowances-header">
              {isContractEstimate ? (
                <span className="font-medium text-[12px] capitalize tracking-wide" style={{ color: "#ffffff", textDecoration: "none" }}>Margin and Allowances</span>
              ) : (
                <h4
                  className="result-heading cursor-pointer text-[12px] font-medium capitalize tracking-wide m-0"
                  style={{ color: "#ffffff", textDecoration: "underline" }}
                  onClick={() => setMarginModal(true)}
                >
                  Margin and Allowances
                </h4>
              )}
            </Grid>

            <Grid item xs={12}>
              <table className="fleet-result-table margin-allowances-table">
                <tr>
                  <th className="text-[11px]" style={{ color: "#000000" }}>
                    DWF
                  </th>
                  {showDwfViewReset ? (
                    <>
                      <td>
                        {" "}
                        <input
                          type="number"
                          onKeyDown={handleKeyDown}
                          name="dwf"
                          value={localDwf}
                          onFocus={() => setFocusedMarginField("dwf")}
                          onChange={onMarginLocalChange("dwf", setLocalDwf)}
                          onBlur={onMarginBlur("dwf", setLocalDwf)}
                        />
                      </td>
                      <td>%</td>
                    </>
                  ) : (
                    <>
                      <td>
                        <span className="cursor-pointer" style={{ color: "#000000", textDecoration: "underline" }} onClick={() => setMarginModal(true)}>View</span>
                      </td>
                      <td>
                        <span className="cursor-pointer" style={{ color: "#000000", textDecoration: "underline" }} onClick={() => onChangeViewReset("dwf")}>
                          Reset
                        </span>
                      </td>
                    </>
                  )}
                </tr>
                <tr>
                  <th className="text-[11px]" style={{ color: "#000000" }}>
                    Speed Perf Factor
                  </th>
                  {showSpeedFactorViewReset ? (
                    <>
                      <td>
                        {" "}
                        <input
                          type="number"
                          onKeyDown={handleKeyDown}
                          name="speedFactor"
                          value={localSpeedFactor}
                          onFocus={() => setFocusedMarginField("speedFactor")}
                          onChange={onMarginLocalChange("speedFactor", setLocalSpeedFactor)}
                          onBlur={onMarginBlur("speedFactor", setLocalSpeedFactor)}
                        />
                      </td>
                      <td>%</td>
                    </>
                  ) : (
                    <>
                      <td>
                        <span className="cursor-pointer" style={{ color: "#000000", textDecoration: "underline" }} onClick={() => setMarginModal(true)}>View</span>
                      </td>
                      <td>
                        <span className="cursor-pointer" style={{ color: "#000000", textDecoration: "underline" }} onClick={() => onChangeViewReset("speedFactor")}>
                          Reset
                        </span>
                      </td>
                    </>
                  )}
                </tr>
                <tr>
                  <th className="text-[11px]" style={{ color: "#000000" }}>
                    Speed Reduce
                  </th>
                  {showSpeedReduceViewReset ? (
                    <>
                      <td>
                        {" "}
                        <input
                          type="number"
                          onKeyDown={handleKeyDown}
                          name="speedReduce"
                          value={localSpeedReduce}
                          onFocus={() => setFocusedMarginField("speedReduce")}
                          onChange={onMarginLocalChange("speedReduce", setLocalSpeedReduce)}
                          onBlur={onMarginBlur("speedReduce", setLocalSpeedReduce)}
                        />
                      </td>
                      <td>Knots</td>
                    </>
                  ) : (
                    <>
                      <td>
                        <span className="cursor-pointer" style={{ color: "#000000", textDecoration: "underline" }} onClick={() => setMarginModal(true)}>View</span>
                      </td>
                      <td>
                        <span className="cursor-pointer" style={{ color: "#000000", textDecoration: "underline" }} onClick={() => onChangeViewReset("speedReduce")}>
                          Reset
                        </span>
                      </td>
                    </>
                  )}
                </tr>
                <tr>
                  <th className="text-[11px]" style={{ color: "#000000" }}>
                    Bunker Con Allowance
                  </th>
                  {showBunkerConViewReset ? (
                    <>
                      <td>
                        {" "}
                        <input
                          type="number"
                          onKeyDown={handleKeyDown}
                          name="bnkrFactor"
                          value={localBnkrFactor}
                          onFocus={() => setFocusedMarginField("bnkrFactor")}
                          onChange={onMarginLocalChange("bnkrFactor", setLocalBnkrFactor)}
                          onBlur={onMarginBlur("bnkrFactor", setLocalBnkrFactor)}
                        />
                      </td>
                      <td>%</td>
                    </>
                  ) : (
                    <>
                      <td>
                        <span className="cursor-pointer" style={{ color: "#000000", textDecoration: "underline" }} onClick={() => setMarginModal(true)}>View</span>
                      </td>
                      <td>
                        <span className="cursor-pointer" style={{ color: "#000000", textDecoration: "underline" }} onClick={() => onChangeViewReset("bnkrFactor")}>
                          Reset
                        </span>
                      </td>
                    </>
                  )}
                </tr>
                <tr>
                  <th className="text-[11px]" style={{ color: "#000000" }}>
                    Fuel Calculation Method
                  </th>
                  <td colSpan={2}>
                    <select
                      value={fuelCalculationMethod}
                      name="fuelCalculationMethod"
                      onChange={onChangeHandler}
                      className="w-full h-[15px] bg-[#fef9c3] text-[11px] font-medium text-slate-800 outline-none border-none cursor-pointer"
                    >
                      <option value="DEFAULT">DEFAULT</option>
                      <option value="LIFO">LIFO</option>
                      <option value="FIFO">FIFO</option>
                      <option value="AVERAGE">AVERAGE</option>
                    </select>
                  </td>
                </tr>
              </table>
            </Grid>
            {isFromVesselVessel ? (
              <>
                <h4 className="result-heading m-t-5">Expenses</h4>
                <table className="fleet-result-table">
                  {expenseResultField.map((item, key) => {
                    const isDailyExpenses = item.value === "expensesPerDay";
                    const hasItemsKey = Boolean(item.itemsKey);

                    const dailyExpensesSum = isDailyExpenses
                      ? (
                        calculatorData?.clientQuery?.dailyExpenses || []
                      ).reduce((sum, entry) => {
                        if (entry.value && entry.label) {
                          return sum + Number(entry.value);
                        }
                        return sum;
                      }, 0)
                      : 0;

                    // For expense keys with breakdown: compute sum from items array
                    let breakdownSum = 0;
                    if (hasItemsKey) {
                      const items = calculatorData?.clientQuery?.[item.itemsKey];
                      if (items && Array.isArray(items)) {
                        breakdownSum = items.reduce(
                          (sum, entry) => sum + (Number(entry.value) || 0),
                          0
                        );
                      } else {
                        // Auto-migrate: if there's a plain number value but no items array,
                        // use the existing value as the sum
                        breakdownSum = Number(clientQuery[item.value]) || 0;
                      }
                    }

                    const openExpenseModal = () => {
                      if (isDailyExpenses) return setShowExpensesModal(true);
                      // Auto-migrate on first click if no items array exists
                      const existing = calculatorData?.clientQuery?.[item.itemsKey];
                      if (!existing || !Array.isArray(existing)) {
                        const currentVal = Number(clientQuery[item.value]) || 0;
                        setCalculatorData((prev) => ({
                          ...prev,
                          clientQuery: {
                            ...prev.clientQuery,
                            [item.itemsKey]: [{ label: item.label, value: currentVal }],
                          },
                        }));
                      }
                      setExpenseModalField(item);
                    };

                    return (
                      <tr key={key}>
                        <th>
                          {isDailyExpenses ? (
                            <span
                              style={{
                                color: "black",
                                cursor: "pointer",
                                textDecoration: "underline",
                              }}
                              onClick={openExpenseModal}
                            >
                              {item.label}
                            </span>
                          ) : hasItemsKey ? (
                            <span
                              style={{
                                color: "black",
                                cursor: "pointer",
                                textDecoration: "underline",
                              }}
                              onClick={openExpenseModal}
                            >
                              {item.label}
                            </span>
                          ) : (
                            item.label
                          )}
                        </th>
                        <td
                          style={isDailyExpenses || hasItemsKey ? { cursor: "pointer" } : undefined}
                          onClick={isDailyExpenses || hasItemsKey ? openExpenseModal : undefined}
                        >
                          {isDailyExpenses ? (
                            <span style={{ color: "black" }}>
                              {dailyExpensesSum}
                            </span>
                          ) : hasItemsKey ? (
                            <span style={{ color: "black" }}>
                              {breakdownSum}
                            </span>
                          ) : (
                            <input
                              type="number"
                              onKeyDown={handleKeyDown}
                              placeholder="0"
                              onChange={onChangeQueryValues}
                              value={clientQuery[item.value] || ""}
                              name={item.value}
                            />
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </table>
              </>
            ) : !syncBunker ? (
              <Grid item xs={12} className="mt-1">
                <div className="text-[11px] font-medium text-[#0f3459] bg-[#e8f0f8] px-1.5 py-0.5 border border-[#cbd5e1] border-b-0 rounded-t-[2px] leading-tight">Fuel Price</div>
                <table className="vessel-details-tables w-full has-border-top" style={{ tableLayout: "fixed" }}>
                  <thead>
                    <tr>
                      <th style={{ width: "28%", borderTop: "1px solid #cbd5e1" }}>Type</th>
                      <th style={{ width: "24%", borderTop: "1px solid #cbd5e1" }}>Main</th>
                      <th style={{ width: "24%", borderTop: "1px solid #cbd5e1" }}>ECA</th>
                      <th style={{ width: "24%", borderTop: "1px solid #cbd5e1" }}>MGO</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th style={{ width: "28%", background: "#ffffff", padding: "2px 4px", verticalAlign: "middle" }}>
                        <div className="w-full text-[11px] font-medium text-slate-700 truncate text-left" title={(selectedFuelType && selectedFuelType.label) || fuelType || "Type-1"}>
                          {(selectedFuelType && selectedFuelType.label) || fuelType || "Type-1"}
                        </div>
                      </th>
                      <td>
                        <input
                          type="number"
                          onKeyDown={handleKeyDown}
                          placeholder="0"
                          name="normal"
                          onChange={onChangeFuelPrice}
                          value={fuelTypePrices?.[fuelType]?.normal}
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          onKeyDown={handleKeyDown}
                          placeholder="0"
                          name="eca"
                          onChange={onChangeFuelPrice}
                          value={fuelTypePrices?.[fuelType]?.eca}
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          placeholder="0"
                          onKeyDown={handleKeyDown}
                          name="mgo"
                          onChange={onChangeFuelPrice}
                          value={fuelTypePrices?.[fuelType]?.mgo}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid>
            ) : (
              ""
            )}
            <Grid item xs={12} className="mt-1">
              <table className="fleet-result-table has-border-top">
                <thead>
                  <tr>
                    <th colSpan="2" style={{ background: "#e8f0f8", color: "#0f3459", borderTop: "1px solid #cbd5e1", fontWeight: 500 }}>
                      Bunker Fuel specifications
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th style={{ width: "25%" }}>Main</th>
                    <td>
                      <Tooltip
                        title={
                          <span className="text-xs">{bnkFuelMain || "empty"}</span>
                        }
                        placement="top"
                        arrow
                      >
                        <input
                          name="bnkFuelMain"
                          type="text"
                          maxLength={100}
                          placeholder=""
                          value={bnkFuelMain || ""}
                          onChange={vesselOnChangeHandler}
                        />
                      </Tooltip>
                    </td>
                  </tr>
                  <tr>
                    <th>ECA</th>
                    <td>
                      <Tooltip
                        title={
                          <span className="text-xs">{bnkFuelEca || "empty"}</span>
                        }
                        placement="top"
                        arrow
                      >
                        <input
                          name="bnkFuelEca"
                          type="text"
                          maxLength={100}
                          placeholder=""
                          value={bnkFuelEca || ""}
                          onChange={vesselOnChangeHandler}
                        />
                      </Tooltip>
                    </td>
                  </tr>
                  <tr>
                    <th>MDO</th>
                    <td>
                      <Tooltip
                        title={
                          <span className="text-xs">{bnkFuelMgo || "empty"}</span>
                        }
                        placement="top"
                        arrow
                      >
                        <input
                          name="bnkFuelMgo"
                          type="text"
                          maxLength={100}
                          placeholder=""
                          value={bnkFuelMgo || ""}
                          onChange={vesselOnChangeHandler}
                        />
                      </Tooltip>
                    </td>
                  </tr>
                </tbody>
              </table>
            </Grid>

            {!isFromSingleVesselCalcy && !isFromVesselVessel ? (
              <Grid item xs={12}>
                <div className="text-center py-1 font-semibold text-slate-700 text-[13px] bg-slate-50 border border-slate-200 my-1">
                  {(selectedFuelType && selectedFuelType.label) || "Type-1"}
                </div>
              </Grid>
            ) : (
              ""
            )}

            {isFromSingleVesselCalcy ? (
              <Grid item xs={12}>
                <div style={{ marginBottom: 0 }} className="sync-bunker-switch">
                  <label>Override</label>
                  <Switch
                    checked={isOverride}
                    onChange={(e) => setIsOverride(e.target.checked)}
                    name="checkedA"
                    color="primary"
                  />
                </div>
              </Grid>
            ) : (
              ""
            )}

            {isFromSingleVesselCalcy ? (
              <Grid item xs={12}>
                <Grid container className="lower-prices-container">
                  <div className="show-bunker-lower-prices-from-single-vessel">
                    <table>
                      <thead>
                        <tr>
                          <th>Bunker Prices</th>
                          <th>Main</th>
                          <th>ECA</th>
                          <th>MGO</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th> On Delivery</th>
                          <td style={{ backgroundColor: !isOverride ? "#ffffff" : "#ffffd6" }} className={!isOverride ? "bg-white" : "bg-[#ffffd6]"}>
                            {!isOverride ? (
                              <p>{bnkPriceDeliveryhs}</p>
                            ) : (
                              <input
                                onKeyDown={handleKeyDown}
                                type="number"
                                value={bnkPriceDeliveryhs}
                                disabled={!isOverride}
                                name="bnkPriceDeliveryhs"
                                className={!isOverride ? "bg-white cursor-not-allowed" : "bg-[#ffffd6]"}
                                onChange={(e) =>
                                  onChangeSelectedVessel(e, true)
                                }
                              />
                            )}
                          </td>
                          <td style={{ backgroundColor: !isOverride ? "#ffffff" : "#ffffd6" }} className={!isOverride ? "bg-white" : "bg-[#ffffd6]"}>
                            {!isOverride ? (
                              <p>{bnkPriceDeliveryls}</p>
                            ) : (
                              <input
                                onKeyDown={handleKeyDown}
                                type="number"
                                value={bnkPriceDeliveryls}
                                disabled={!isOverride}
                                name="bnkPriceDeliveryls"
                                className={!isOverride ? "bg-white cursor-not-allowed" : "bg-[#ffffd6]"}
                                onChange={(e) =>
                                  onChangeSelectedVessel(e, true)
                                }
                              />
                            )}
                          </td>
                          <td style={{ backgroundColor: !isOverride ? "#ffffff" : "#ffffd6" }} className={!isOverride ? "bg-white" : "bg-[#ffffd6]"}>
                            {!isOverride ? (
                              <p>{bnkPriceDeliverymgo}</p>
                            ) : (
                              <input
                                onKeyDown={handleKeyDown}
                                type="number"
                                value={bnkPriceDeliverymgo}
                                disabled={!isOverride}
                                name="bnkPriceDeliverymgo"
                                className={!isOverride ? "bg-white cursor-not-allowed" : "bg-[#ffffd6]"}
                                onChange={(e) =>
                                  onChangeSelectedVessel(e, true)
                                }
                              />
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th> On Re-Delivery</th>
                          <td style={{ backgroundColor: !isOverride ? "#ffffff" : "#ffffd6" }} className={!isOverride ? "bg-white" : "bg-[#ffffd6]"}>
                            {!isOverride ? (
                              <p>{bnkPriceRedeliveryhs}</p>
                            ) : (
                              <input
                                onKeyDown={handleKeyDown}
                                type="number"
                                value={bnkPriceRedeliveryhs}
                                disabled={!isOverride}
                                name="bnkPriceRedeliveryhs"
                                className={!isOverride ? "bg-white cursor-not-allowed" : "bg-[#ffffd6]"}
                                onChange={(e) =>
                                  onChangeSelectedVessel(e, true)
                                }
                              />
                            )}
                          </td>
                          <td style={{ backgroundColor: !isOverride ? "#ffffff" : "#ffffd6" }} className={!isOverride ? "bg-white" : "bg-[#ffffd6]"}>
                            {!isOverride ? (
                              <p>{bnkPriceRedeliveryls}</p>
                            ) : (
                              <input
                                onKeyDown={handleKeyDown}
                                type="number"
                                value={bnkPriceRedeliveryls}
                                disabled={!isOverride}
                                name="bnkPriceRedeliveryls"
                                className={!isOverride ? "bg-white cursor-not-allowed" : "bg-[#ffffd6]"}
                                onChange={(e) =>
                                  onChangeSelectedVessel(e, true)
                                }
                              />
                            )}
                          </td>
                          <td style={{ backgroundColor: !isOverride ? "#ffffff" : "#ffffd6" }} className={!isOverride ? "bg-white" : "bg-[#ffffd6]"}>
                            {!isOverride ? (
                              <p>{bnkPriceRedeliverymgo}</p>
                            ) : (
                              <input
                                onKeyDown={handleKeyDown}
                                type="number"
                                value={bnkPriceRedeliverymgo}
                                disabled={!isOverride}
                                name="bnkPriceRedeliverymgo"
                                className={!isOverride ? "bg-white cursor-not-allowed" : "bg-[#ffffd6]"}
                                onChange={(e) =>
                                  onChangeSelectedVessel(e, true)
                                }
                              />
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th> For Settlement</th>
                          <td style={{ backgroundColor: !isOverride ? "#ffffff" : "#ffffd6" }} className={!isOverride ? "bg-white" : "bg-[#ffffd6]"}>
                            {!isOverride ? (
                              <p>{bnkPriceSettlemenths}</p>
                            ) : (
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                value={bnkPriceSettlemenths}
                                disabled={!isOverride}
                                name="bnkPriceSettlemenths"
                                className={!isOverride ? "bg-white cursor-not-allowed" : "bg-[#ffffd6]"}
                                onChange={(e) =>
                                  onChangeSelectedVessel(e, true)
                                }
                              />
                            )}
                          </td>
                          <td style={{ backgroundColor: !isOverride ? "#ffffff" : "#ffffd6" }} className={!isOverride ? "bg-white" : "bg-[#ffffd6]"}>
                            {!isOverride ? (
                              <p>{bnkPriceSettlementls}</p>
                            ) : (
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                value={bnkPriceSettlementls}
                                disabled={!isOverride}
                                name="bnkPriceSettlementls"
                                className={!isOverride ? "bg-white cursor-not-allowed" : "bg-[#ffffd6]"}
                                onChange={(e) =>
                                  onChangeSelectedVessel(e, true)
                                }
                              />
                            )}
                          </td>
                          <td style={{ backgroundColor: !isOverride ? "#ffffff" : "#ffffd6" }} className={!isOverride ? "bg-white" : "bg-[#ffffd6]"}>
                            {!isOverride ? (
                              <p>{bnkPriceSettlementmgo}</p>
                            ) : (
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                value={bnkPriceSettlementmgo}
                                disabled={!isOverride}
                                name="bnkPriceSettlementmgo"
                                className={!isOverride ? "bg-white cursor-not-allowed" : "bg-[#ffffd6]"}
                                onChange={(e) =>
                                  onChangeSelectedVessel(e, true)
                                }
                              />
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="show-bunker-lower-prices-from-single-vessel mt-1.5">
                    <table>
                      <thead>
                        <tr>
                          <th>Bunker Qty </th>
                          <th>Main</th>
                          <th>ECA</th>
                          <th>MGO</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th>On Delivery</th>
                          <td>
                            <input
                              type="number"
                              onKeyDown={handleKeyDown}
                              value={bnkDelhs}
                              name="bnkDelhs"
                              onChange={(e) => onChangeSelectedVessel(e, true)}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              onKeyDown={handleKeyDown}
                              value={bnkDells}
                              name="bnkDells"
                              onChange={(e) => onChangeSelectedVessel(e, true)}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              onKeyDown={handleKeyDown}
                              value={bnkDelmgo}
                              name="bnkDelmgo"
                              onChange={(e) => onChangeSelectedVessel(e, true)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>Exp on Re-Delivery</th>
                          <td>
                            <input
                              type="number"
                              onKeyDown={handleKeyDown}
                              value={bnkQtyRedeliveryhs}
                              name="bnkQtyRedeliveryhs"
                              onChange={(e) => onChangeSelectedVessel(e, true)}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              onKeyDown={handleKeyDown}
                              value={bnkQtyRedeliveryls}
                              name="bnkQtyRedeliveryls"
                              onChange={(e) => onChangeSelectedVessel(e, true)}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              onKeyDown={handleKeyDown}
                              value={bnkQtyRedeliverymgo}
                              name="bnkQtyRedeliverymgo"
                              onChange={(e) => onChangeSelectedVessel(e, true)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>Tolerance Acceptable</th>
                          <td>
                            <input
                              type="number"
                              onKeyDown={handleKeyDown}
                              value={bnkRedeliveryQtyTolerancehs}
                              name="bnkRedeliveryQtyTolerancehs"
                              onChange={(e) => onChangeSelectedVessel(e, true)}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              onKeyDown={handleKeyDown}
                              value={bnkRedeliveryQtyTolerancels}
                              name="bnkRedeliveryQtyTolerancels"
                              onChange={(e) => onChangeSelectedVessel(e, true)}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              onKeyDown={handleKeyDown}
                              value={bnkRedeliveryQtyTolerancemgo}
                              name="bnkRedeliveryQtyTolerancemgo"
                              onChange={(e) => onChangeSelectedVessel(e, true)}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Grid>
              </Grid>
            ) : (
              ""
            )}

            {!isFromSingleVesselCalcy ? (
              <Grid item xs={12} className="!mb-0">
                <div className="text-[11px] font-medium text-slate-700 px-1 py-0 mt-0.5">This Vessel:</div>
                <table className="fleet-result-table w-full has-border-top">

                  <tr>
                    <th style={{ borderTop: "1px solid #cbd5e1" }}>TC Adcom %</th>
                    <td style={{ borderTop: "1px solid #cbd5e1" }}>
                      <input
                        type="number"
                        name="tcAdcom"
                        placeholder="0"
                        value={selectedVessels?.tcAdcom}
                        onKeyDown={handleKeyDown}
                        onChange={(e) => onChangeSelectedVessel(e, true)}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>Brokerage:
                    </th>
                    <td>
                      <input
                        type="number"
                        name="brokerage"
                        placeholder="0"
                        value={(selectedVessels && selectedVessels.brokerage) || 0}
                        onKeyDown={handleKeyDown}
                        onChange={(e) => onChangeSelectedVessel(e, true)}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>Extra Expenses</th>
                    <td>
                      <input
                        type="number"
                        onKeyDown={handleKeyDown}
                        placeholder="0"
                        onChange={(e) => onChangeSelectedVessel(e, true)}
                        value={
                          (selectedVessels && selectedVessels.extraExpense) || 0
                        }
                        name="extraExpense"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>Constants</th>
                    <td>
                      <input
                        type="number"
                        onKeyDown={handleKeyDown}
                        placeholder="0"
                        onChange={(e) => onChangeSelectedVessel(e, true)}
                        value={
                          (selectedVessels && selectedVessels.constants) || 0
                        }
                        name="constants"
                      />
                    </td>
                  </tr>
                </table>
              </Grid>
            ) : (
              ""
            )}
          </Grid>
        </div>
      </Grid>
      <CustomShowModal
        open={showExpensesModal}
        handleClose={() => setShowExpensesModal(false)}
        title="Daily Expenses"
      >
        <DailyExpensesModal
          dailyExpenses={dailyExpenses}
          setCalculatorData={setCalculatorData}
          calculatorData={calculatorData}
        />
      </CustomShowModal>
      {expenseModalField && (
        <CustomShowModal
          open={Boolean(expenseModalField)}
          handleClose={() => setExpenseModalField(null)}
          maxWidth="xs"
          title={expenseModalField.label}
        >
          <ExpenseBreakdownModal
            expenseLabel={expenseModalField.label}
            items={
              calculatorData?.clientQuery?.[expenseModalField.itemsKey] ||
              [{ label: expenseModalField.label, value: Number(clientQuery[expenseModalField.value]) || 0 }]
            }
            onChange={(updatedItems, sum) => {
              setCalculatorData((prev) => ({
                ...prev,
                clientQuery: {
                  ...prev.clientQuery,
                  [expenseModalField.itemsKey]: updatedItems,
                  [expenseModalField.value]: sum,
                },
              }));
            }}
          />
        </CustomShowModal>
      )}
    </Grid>
  );
}

export default MarginAndAllowances;
